/** Attribute-not-loaded error. */
export default class AttributeNotLoadedError extends Error {}
